module.exports = __webpack_public_path__ + "img/icon_setup_mianrong@3x.9a233af5.png";